// frontend/src/pages/Sobre.jsx
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Users,
  Leaf,
  Store,
  UserPlus,
  Megaphone,
  MessageCircle,
  Handshake,
  Shield,
  ChevronRight,
  CheckCircle2,
} from "lucide-react";

export default function Sobre() {
  const beneficios = [
    "Menos desperdício",
    "Mais economia para as famílias",
    "Mais integração entre moradores",
    "Apoio aos empreendedores locais",
    "Mais circulação de recursos dentro da comunidade",
    "Maior senso de pertencimento",
  ];

  const pilares = [
    {
      icon: Users,
      titulo: "Comunidade",
      texto:
        "Fortalecemos a conexão entre moradores e incentivamos relações de confiança.",
    },
    {
      icon: Leaf,
      titulo: "Sustentabilidade",
      texto:
        "Promovemos o reaproveitamento de bens e ajudamos a reduzir desperdícios.",
    },
    {
      icon: Store,
      titulo: "Economia Local",
      texto:
        "Valorizamos empreendedores, profissionais e negócios da própria comunidade.",
    },
  ];

  const passos = [
    {
      icon: UserPlus,
      titulo: "Criar Conta",
      texto: "Cadastre-se e faça parte da comunidade.",
    },
    {
      icon: Megaphone,
      titulo: "Publicar",
      texto: "Anuncie itens, doações, produtos ou serviços.",
    },
    {
      icon: MessageCircle,
      titulo: "Conectar",
      texto: "Converse com outros moradores através do chat da plataforma.",
    },
    {
      icon: Handshake,
      titulo: "Negociar",
      texto: "Combine diretamente com o interessado de forma simples e segura.",
    },
  ];

  return (
    <>
      {/* Estilos para impressão */}
      <style>
        {`
          @media print {
            body { margin: 0; padding: 0; background: white; }
            .no-print { display: none !important; }
            .print-content { margin: 0; padding: 0.5cm; width: 100%; }
            .sobre-hero { min-height: auto !important; padding: 1cm 0 !important; }
            .sobre-section { page-break-inside: avoid; }
            .sobre-grid { display: flex !important; flex-wrap: wrap !important; gap: 0.5cm !important; }
            .sobre-card { flex: 1 !important; min-width: 200px !important; }
            @page { size: A4; margin: 1.5cm; }
          }
        `}
      </style>

      <div className="min-h-screen bg-gray-50 pt-2 pb-12">
        <div className="max-w-7xl mx-auto px-4">
          {/* Header com voltar */}
          <div className="no-print bg-white rounded-2xl shadow-sm border border-gray-100 p-3 md:p-6 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 md:gap-3 min-w-0">
                <img
                  src={`${process.env.PUBLIC_URL}/img/logo2.png`}
                  alt="Brechó Vizinho"
                  className="h-8 md:h-12 w-auto object-contain flex-shrink-0"
                />
                <div className="min-w-0">
                  <h1 className="text-sm md:text-xl font-bold text-gray-800 truncate">
                    Sobre o Brechó Vizinho
                  </h1>
                  <p className="text-[10px] md:text-xs text-gray-500 hidden sm:block">
                    Conheça nossa história e propósito
                  </p>
                </div>
              </div>

              <button
                onClick={() => window.history.back()}
                className="flex items-center gap-1 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors flex-shrink-0 text-sm md:text-base"
              >
                <ArrowLeft className="w-4 h-4 md:w-5 md:h-5" />
                <span className="text-xs md:text-sm">Voltar</span>
              </button>
            </div>
          </div>

          {/* ==================== SEÇÃO 1 - HERO CON BOTONES DEBAJO ==================== */}
          <section className="mb-12 sobre-hero">
            <div className="relative w-full rounded-2xl overflow-hidden">
              <div
                className="block sm:hidden"
                style={{ paddingBottom: "46.6%" }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/herosobremobile.png`}
                  alt="Brechó Vizinho - Comunidade"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                />
              </div>
              <div className="hidden sm:block" style={{ paddingBottom: "20%" }}>
                <img
                  src={`${process.env.PUBLIC_URL}/herosobre.png`}
                  alt="Brechó Vizinho - Comunidade"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/registro"
                className="bg-[#449879] hover:bg-[#367d64] text-white px-8 py-3 rounded-xl font-semibold transition-colors shadow-lg hover:shadow-xl text-center"
              >
                Começar Agora
              </Link>
              <Link
                to="/"
                className="bg-white hover:bg-gray-50 text-[#449879] border-2 border-[#449879] px-8 py-3 rounded-xl font-semibold transition-colors shadow-lg hover:shadow-xl text-center"
              >
                Conhecer a Plataforma
              </Link>
            </div>
          </section>

          {/* ==================== SEÇÃO 2 - O QUE É ==================== */}
          <section className="grid md:grid-cols-2 gap-6 md:gap-12 mb-16 sobre-section">
            <div className="flex flex-col justify-center order-2 md:order-1">
              <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-3 md:mb-4">
                Uma plataforma feita para a comunidade
              </h2>
              <p className="text-gray-600 leading-relaxed text-sm md:text-lg mb-3 md:mb-4">
                O Brechó Vizinho nasceu para facilitar a conexão entre
                moradores, incentivar a reutilização de bens, fortalecer a
                economia local e criar novas oportunidades dentro da comunidade.
              </p>
              <p className="text-gray-600 leading-relaxed text-sm md:text-lg">
                Aqui você pode vender, doar, encontrar oportunidades, divulgar
                serviços e apoiar empreendedores da sua região de forma simples
                e organizada.
              </p>
              <div className="mt-4 md:mt-6 flex flex-wrap gap-2 md:gap-3">
                <span className="bg-green-50 text-[#449879] px-2.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-medium">
                  Vender
                </span>
                <span className="bg-green-50 text-[#449879] px-2.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-medium">
                  Doar
                </span>
                <span className="bg-green-50 text-[#449879] px-2.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-medium">
                  Conectar
                </span>
                <span className="bg-green-50 text-[#449879] px-2.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-medium">
                  Empreender
                </span>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="rounded-2xl overflow-hidden bg-gray-100 w-full">
                <img
                  src={`${process.env.PUBLIC_URL}/umaplataformafeita.png`}
                  alt="Uma plataforma feita para a comunidade"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </section>

          {/* ==================== SEÇÃO 3 - PILARES ==================== */}
          <section className="mb-16 sobre-section">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-12">
              Nossos Pilares
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              {pilares.map((pilar, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow text-center"
                >
                  <div className="w-14 h-14 bg-[#449879]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <pilar.icon className="w-7 h-7 text-[#449879]" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    {pilar.titulo}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {pilar.texto}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* ==================== SEÇÃO 4 - COMO FUNCIONA ==================== */}
          <section className="mb-16 sobre-section">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-12">
              Como Funciona
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {passos.map((passo, index) => (
                <div key={index} className="relative text-center">
                  {index < passos.length - 1 && (
                    <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-[#449879]/20">
                      <ChevronRight className="w-4 h-4 text-[#449879]/30 absolute -right-2 -top-2" />
                    </div>
                  )}
                  <div className="w-16 h-16 bg-[#449879] rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg shadow-[#449879]/20">
                    <passo.icon className="w-7 h-7 text-white" />
                  </div>
                  <p className="font-semibold text-gray-800 text-sm">
                    {passo.titulo}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">{passo.texto}</p>
                </div>
              ))}
            </div>
          </section>

          {/* ==================== SEÇÃO 5 - BENEFÍCIOS ==================== */}
          <section className="grid md:grid-cols-2 gap-8 md:gap-12 mb-16 sobre-section">
            <div className="rounded-2xl overflow-hidden bg-gray-100 border-2 border-[#449879]/10 w-full">
              <img
                src={`${process.env.PUBLIC_URL}/familia.png`}
                alt="Famílias, vizinhos e empreendedores locais"
                className="w-full h-auto object-contain"
              />
            </div>
            <div className="flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                Quando a comunidade ganha, todos ganham
              </h2>
              <ul className="space-y-3">
                {beneficios.map((beneficio, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-[#449879] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600">{beneficio}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* ==================== SEÇÃO 6 - EMPREENDEDORES (SOLO IMAGEN) ==================== */}
          <section className="mb-16 sobre-section relative rounded-2xl overflow-hidden">
            {/* 🔥 Imagen de fondo parte.png - SOLO IMAGEN */}
            <div className="absolute inset-0">
              <img
                src={`${process.env.PUBLIC_URL}/parte.png`}
                alt="Valorizando quem empreende"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40"></div>
            </div>

            {/* 🔥 Contenido sobre la imagen - SOLO TÍTULO Y DESCRIPCIÓN */}
            <div className="relative z-10 px-6 py-16 md:py-20 text-center text-white">
              <h2 className="text-2xl md:text-4xl font-bold mb-4">
                Valorizando quem empreende perto de você
              </h2>
              <p className="text-white/90 text-sm md:text-base max-w-2xl mx-auto">
                O Brechó Vizinho também foi criado para apoiar moradores
                empreendedores, profissionais autônomos e pequenos negócios
                locais, ajudando-os a divulgar seus produtos e serviços para
                pessoas da própria comunidade.
              </p>
            </div>
          </section>

          {/* ==================== SEÇÃO 7 - SEGURANÇA ==================== */}
          <section className="mb-16 sobre-section">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 border border-blue-100">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
                    <Shield className="w-10 h-10 text-blue-600" />
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                    Construindo uma comunidade mais segura
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    Utilizamos mecanismos de validação de usuários e ferramentas
                    de moderação para promover um ambiente baseado em respeito,
                    colaboração e confiança.
                  </p>
                  <p className="text-gray-600 leading-relaxed mt-2">
                    As negociações acontecem diretamente entre os usuários, mas
                    trabalhamos continuamente para oferecer uma experiência
                    positiva para todos.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* ==================== SEÇÃO 8 - VISÃO ==================== */}
          <section className="mb-16 sobre-section text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                Nossa Visão
              </h2>
              <p className="text-gray-600 leading-relaxed text-base md:text-lg mb-4">
                Queremos transformar o Brechó Vizinho em uma referência de
                economia colaborativa e conexões comunitárias.
              </p>
              <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                Acreditamos que comunidades fortes são construídas quando as
                pessoas compartilham, colaboram e se ajudam mutuamente.
              </p>
              <div className="mt-6 inline-block bg-[#449879]/10 rounded-full px-6 py-3 border border-[#449879]/20">
                <p className="text-[#449879] font-semibold text-lg">
                  ✨ Uma plataforma de intercâmbios dentro da nossa comunidade.
                </p>
              </div>
            </div>
          </section>

          {/* ==================== SEÇÃO 9 - CHAMADA FINAL (FONDO VERDE BRECHÓ) ==================== */}
          <section className="rounded-2xl overflow-hidden sobre-section bg-[#449879]">
            <div className="px-6 py-16 md:py-20 text-center text-white">
              <h2 className="text-2xl md:text-4xl font-bold mb-4">
                Faça parte da comunidade
              </h2>
              <p className="text-white/90 text-base md:text-lg max-w-2xl mx-auto mb-8">
                Descubra oportunidades, conecte-se com seus vizinhos e ajude a
                construir uma comunidade mais forte e colaborativa.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                  to="/registro"
                  className="bg-white text-[#449879] px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors shadow-lg hover:shadow-xl"
                >
                  Criar Minha Conta
                </Link>
                <Link
                  to="/"
                  className="bg-white/20 backdrop-blur-sm text-white border border-white/30 px-8 py-3 rounded-xl font-semibold hover:bg-white/30 transition-colors"
                >
                  Explorar Anúncios
                </Link>
              </div>
            </div>
          </section>

          {/* ==================== RODAPÉ ==================== */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-2">
                  Documentos Legais
                </h4>
                <ul className="space-y-1">
                  <li>
                    <Link
                      to="/termos"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Termos de Uso
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacidade"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Privacidade
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/comunidade"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política da Comunidade
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/publicidade"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Publicidade
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-2">
                  &nbsp;
                </h4>
                <ul className="space-y-1">
                  <li>
                    <Link
                      to="/cookies"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Cookies
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/reembolso"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Reembolso
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/validacao"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Validação
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/politica-chat"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      Política de Chat
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-2">
                  Contato
                </h4>
                <ul className="space-y-1">
                  <li>
                    <a
                      href="mailto:contato@brechovizinho.com.br"
                      className="text-xs text-gray-500 hover:text-[#449879] transition-colors"
                    >
                      info@brechovizinho.com.br
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-2">
                  Redes Sociais
                </h4>
                <div className="flex gap-2">
                  <a
                    href="#"
                    className="text-gray-400 hover:text-[#449879] transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-[#449879] transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="text-center pt-4 border-t border-gray-100">
              <p className="text-[10px] text-gray-400">
                © {new Date().getFullYear()} Brechó Vizinho - Todos os direitos
                reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
